var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1128,
    height: 276,
    viewBox: "0 0 1128 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1128,
    height: 276,
    fill: "#F2F6F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M271 88L281.353 99.363L296 94.6987L299.284 109.716L314.301 113L309.637 127.647L321 138L309.637 148.353L314.301 163L299.284 166.284L296 181.301L281.353 176.637L271 188L260.647 176.637L246 181.301L242.716 166.284L227.699 163L232.363 148.353L221 138L232.363 127.647L227.699 113L242.716 109.716L246 94.6987L260.647 99.363L271 88Z",
    fill: "#FFA5C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M423 88L444.213 116.787L473 138L444.213 159.213L423 188L401.787 159.213L373 138L401.787 116.787L423 88Z",
    fill: "#FF5F28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M625 149.107L575 88L525 149.107H556.824L525 188H625L593.176 149.107H625Z",
    fill: "#058CD7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M714.45 186L716.045 150.833L686.152 169.917L677 154.083L708.74 138L677 121.917L686.152 106.083L716.045 125.167L714.45 90H732.67L731.075 125.167L760.968 106.083L770.12 121.917L738.38 138L770.12 154.083L760.968 169.917L731.075 150.833L732.67 186H714.45Z",
    fill: "#FFBE14"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M867.657 188L884.162 88H895.952L879.446 188H867.657ZM822.12 161.242L824.036 149.523H900.274L898.359 161.242H822.12ZM832.289 188L848.794 88H860.583L844.078 188H832.289ZM827.966 126.477L829.882 114.758H906.12L904.204 126.477H827.966Z",
    fill: "#058C50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElements);
export default __webpack_public_path__ + "static/media/elements.270b8d166567152a02709d4076fc13d9.svg";
export { ForwardRef as ReactComponent };